import { render, staticRenderFns } from "./BirthdayModal.vue?vue&type=template&id=2d08fd6c&"
import script from "./BirthdayModal.vue?vue&type=script&lang=js&"
export * from "./BirthdayModal.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports